import React from 'react';
import pic from "./Logo.png"

function Reflect() {
  return <img id='soc-logo' src={pic} alt="Soc Logo" width='10em'/>;
}

export default Reflect;